import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IFedexCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class FedexCredentialsStore implements ICredentialsStore {
    private _changes: IFedexCredentialsModel = {} as IFedexCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get webserviceClientId() { return this._changes.webservice_client_id; };
    public get webserviceClientSecret() { return this._changes.webservice_client_secret; };
    public get internalName() { return this._changes.internal_name; };
    public get apiKey() { return this._changes.api_key; };

    setInternalName(value: string) {
        this._changes.internal_name = value;
    };

    setApiKey(value: string) {
        this._changes.api_key = value;
    };

    setWebserviceClientId(value: string) {
        this._changes.webservice_client_id = value;
    };

    setWebserviceClientSecret(value: string) {
        this._changes.webservice_client_secret = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        console.log(this._changes)
        return { ...this._changes };
    }
}

export default FedexCredentialsStore;
